import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import 'react-loading-skeleton/dist/skeleton.css'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { GlobalStyle } from 'styles/global-styles'
import { NotFoundPage } from './components/NotFoundPage/Loadable'
import { useToken } from './hooks'

import { NotFoundPageFake } from './components/NotFoundPageFake'
import { LoadingSpinner } from './components'
import { APPNAME } from './constants/APIKEYS'
import { useDevKey } from './hooks/auth/devkey'
import { useExchangeStore } from './hooks/trade/exchangeStore'
import { LoginPage } from './pages/AuthenticationPages/LoginPage'
import BannedPage from './pages/BannedPage'
import EmptyPage from './pages/EmptyPage'
import './styles.css'

// Lazy load admin pages for code splitting
const AdminOverViewPage = React.lazy(() => import('./adminpages/AdminOverview').then(m => ({ default: m.AdminOverViewPage })))
const AdminUsersPage = React.lazy(() => import('./adminpages/AdminUsers').then(m => ({ default: m.AdminUsersPage })))
const AdminBalancePage = React.lazy(() => import('./adminpages/AdminBalance').then(m => ({ default: m.AdminBalancePage })))
const AdminCashPage = React.lazy(() => import('./adminpages/AdminCash').then(m => ({ default: m.AdminCashPage })))
const AdminCoinPage = React.lazy(() => import('./adminpages/AdminCoin').then(m => ({ default: m.AdminCoinPage })))
const AdminEventsPage = React.lazy(() => import('./adminpages/AdminEvents').then(m => ({ default: m.AdminEventsPage })))
const AdminMemberResponsePage = React.lazy(() => import('./adminpages/AdminMemberResponse').then(m => ({ default: m.AdminMemberResponsePage })))
const AdminPositionPage = React.lazy(() => import('./adminpages/AdminPosition').then(m => ({ default: m.AdminPositionPage })))
const AdminPriceCheckPage = React.lazy(() => import('./adminpages/AdminPriceCheck').then(m => ({ default: m.AdminPriceCheckPage })))
const AdminRecordDetailsPage = React.lazy(() => import('./adminpages/AdminRecordDetails').then(m => ({ default: m.AdminRecordDetailsPage })))
const AdminSystemPage = React.lazy(() => import('./adminpages/AdminSystem').then(m => ({ default: m.AdminSystemPage })))
const AdminTicketPage = React.lazy(() => import('./adminpages/AdminTicket').then(m => ({ default: m.AdminTicketPage })))
const AdminTransactionPage = React.lazy(() => import('./adminpages/AdminTransaction').then(m => ({ default: m.AdminTransactionPage })))
const AdminUserGroupPage = React.lazy(() => import('./adminpages/AdminUserGroup').then(m => ({ default: m.AdminUserGroupPage })))
export function Routes() {
	const { i18n } = useTranslation()
	const { data: token, mutate } = useToken()
	const { data: devkey } = useDevKey()

	const { EPs } = useExchangeStore()

	if (!EPs || EPs?.length === 0) {
		return null
	}

	return (
		<BrowserRouter>
			<Helmet
				titleTemplate="%s"
				defaultTitle={APPNAME + ' ADMIN GLOBAL'}
				htmlAttributes={{ lang: i18n.language }}>
				<meta name="description" content="GLOBAL FUTURES" />
			</Helmet>

			<React.Suspense fallback={<LoadingSpinner />}>
				<Switch>
					<Route exact path="/logout" component={EmptyPage} />


				{!devkey && <Route path="*" component={NotFoundPageFake} />}

				{!token && <Route path="*" component={LoginPage} />}

				<Route exact path="/banned" component={BannedPage} />
				<Route
					exact
					path="/login/"
					component={token ? AdminOverViewPage : LoginPage}
				/>

				<Route
					exact
					path="/"
					component={token ? AdminOverViewPage : LoginPage}
				/>

				<Route
					exact
					path="/usergroup/"
					component={AdminUserGroupPage}
				/>
				<Route
					exact
					path="/usergroup/*"
					component={AdminUserGroupPage}
				/>

				<Route exact path="/users/" component={AdminUsersPage} />
				<Route exact path="/users/*" component={AdminUsersPage} />

				<Route exact path="/position/*" component={AdminPositionPage} />
				<Route exact path="/coin/*" component={AdminCoinPage} />

				<Route
					exact
					path="/record/*"
					component={AdminRecordDetailsPage}
				/>
				<Route
					exact
					path="/transaction/*"
					component={AdminTransactionPage}
				/>
				<Route exact path="/cash/*" component={AdminCashPage} />

				<Route exact path="/ticket" component={AdminTicketPage} />
				<Route exact path="/ticket/*" component={AdminTicketPage} />

				<Route exact path="/balance" component={AdminBalancePage} />
				<Route exact path="/balance/*" component={AdminBalancePage} />
				<Route exact path="/events/" component={AdminEventsPage} />
				<Route exact path="/events/*" component={AdminEventsPage} />
				<Route
					exact
					path="/price-check"
					component={AdminPriceCheckPage}
				/>
				<Route exact path="/system" component={AdminSystemPage} />
				<Route exact path="/system/*" component={AdminSystemPage} />
				<Route
					exact
					path="/member-response"
					component={AdminMemberResponsePage}
				/>
					<Route path="*" component={NotFoundPage} />
				</Switch>
			</React.Suspense>
			<GlobalStyle />
		</BrowserRouter>
	)
}
